import * as actions from './actions';
import * as components from './components';
import reducer from './reducer';
import * as selectors from './selectors';
import sagas from './sagas';
import * as constants from './constants';

export default { actions, components, constants, reducer, selectors, sagas };
